import { Component,Inject  } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog',
  standalone: true,
  imports: [],
  templateUrl: './dialog.component.html',
  styleUrl: './dialog.component.scss'
})
export class DialogComponent {
  selectedProjectCodes: string[] = [];
  showWarning:boolean= true;

constructor(@Inject(MAT_DIALOG_DATA) public data: { projectCodes: string[] },
private dialogRef: MatDialogRef<DialogComponent> ){}

submit(): void {
    this.dialogRef.close(this.selectedProjectCodes); // Pass selected codes back
  }

  onCancel(): void {
  this.dialogRef.close(null); // optionally pass data like this.dialogRef.close('cancelled')
}
}
